import { Injectable, OnApplicationBootstrap } from "@nestjs/common";
import { ConfigEntity, ConfigRepository } from "@ip6m/server/data-access-config";
import { getCustomRepository } from "typeorm";

@Injectable()
export class ConfigurationService implements OnApplicationBootstrap {

    repo: ConfigRepository;

    onApplicationBootstrap() {
        this.repo = getCustomRepository(ConfigRepository);
        this.repo.init();
    }

    get getConfiguration(): Promise<ConfigEntity> {
        return this.repo.getConfiguration();
    }

    async isUserRegisterEnabled(): Promise<boolean> {
        const config = await this.getConfiguration;
        return config.userRegisterEnabled;
    }

    isUserRegisterModerated(): boolean {
        return true;
    }
}
